module.exports = __webpack_public_path__ + "static/media/rss-square.4409fc8f.svg";